import { useState } from "react";
import { forgotPassword } from "../api/auth";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    try {
      const res = await forgotPassword(email);
      setMessage(res.data.message || "If the account exists, a reset link has been sent.");
    } catch (err) {
      setError(err.response?.data?.message || "Unable to request password reset.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="d-flex align-items-center gap-3 mb-4">
          <div className="brand-mark">CV</div>

          <div>
            <h4 className="mb-0">CounselVault</h4>
            <div className="text-muted small">
              Secure privileged legal mail infrastructure
            </div>
          </div>
        </div>

        <div className="mb-4">
          <h2 className="fw-bold mb-2">Forgot Password</h2>
          <p className="text-muted mb-0">
            Enter your email address and we will send a secure reset link.
          </p>
        </div>

        {message && <div className="alert alert-success py-2">{message}</div>}
        {error && <div className="alert alert-danger py-2">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Email Address</label>
            <input
              className="form-control form-control-lg"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button className="btn btn-dark btn-lg w-100" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <div className="text-center mt-4">
          <a href="/login">Back to sign in</a>
        </div>
      </div>
    </div>
  );
}
